export enum AbsenceAccidentSubTypeEnumeration {
	WORK = 'accidentWork',
	FREE_TIME = 'accidentFreeTime',
}
